import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-facebook\"><defs><style>#icon-facebook .cls-1{fill:#fff;}</style></defs><path class=\"cls-1\" d=\"M10.66,19.77H1.3A1.08,1.08,0,0,1,.22,18.69V1.3A1.08,1.08,0,0,1,1.3.22H18.68A1.08,1.08,0,0,1,19.76,1.3V18.69a1.08,1.08,0,0,1-1.08,1.08h-5V12.2h2.55l.38-2.95H13.7V7.37c0-.86.24-1.44,1.47-1.44h1.56V3.29c-.27,0-1.2-.11-2.28-.11a3.55,3.55,0,0,0-3.79,3.9V9.25H8.11V12.2h2.55v7.57Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol